// Custom.js for customized scripts

jQuery(function(){

  
  if(jQuery('a.faq-links').length){
  
    jQuery('a.faq-links').each(function(){
      jQuery(this).click(function(){
        var location = jQuery(this).attr('href');
        jQuery('html, body').animate({
          scrollTop: jQuery(location).offset().top - 40
        }, 1000);
      });
  	});
  
  }
  
  
});

